<div class="container">
    <h1>📸 Ladda upp tävlingsbilder</h1>

    <p>
        Denna guide visar dig hur du laddar upp dina bilder till fototävlingen efter att du
        har loggat in.
    </p>

    <h2>Komma igång med bilduppladdning</h2>

    <div class="step">
        <p class="step-number">Steg 1: Öppna uppladdningsfunktionen</p>
        <p>
            Efter att du har loggat in, klicka på menyn
            <span class="highlight">"Tävling"</span> i navigeringsfältet högst upp på sidan.
            Välj sedan <span class="highlight">"Lägg till bilder"</span> i menyn som öppnas.
        </p>
        <img src="assets/menu.jpg" alt="Meny för att lägga till bilder" style="
                        width: 100%;
                        max-width: 600px;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
    </div>

    <div class="step">
        <p class="step-number">Steg 2: Starta bilduppladdning</p>
        <p>
            Du kommer nu till uppladdningssidan där du ser dina teman. Klicka på
            <strong>plus-knappen (+)</strong> för det tema du vill ladda upp en bild till.
        </p>
        <img src="assets/upload_start.jpg" alt="Starta uppladdning" style="
                        width: 100%;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
    </div>

    <h2>Välj och ladda upp din bild</h2>

    <div class="step">
        <p class="step-number">Steg 3: Välj din bild</p>
        <p>En uppladdningsruta öppnas. Du har nu två alternativ för att välja din bild:</p>
        <img src="assets/upload_modal.jpg" alt="Uppladdningsmodal" style="
                        width: 100%;
                        max-width: 600px;
                        margin: 15px 0;
                        border: 1px solid #ddd;
                        border-radius: 4px;
                    " />
    </div>

    <h3>Alternativ 1: Klicka och välj</h3>
    <div class="info-box">
        <p>
            Klicka på det ljusblå fältet med texten
            <strong>"Släpp en fil här eller klicka"</strong>. En filväljare öppnas där du
            kan bläddra och välja den bild du vill ladda upp från din dator.
        </p>
    </div>

    <h3>Alternativ 2: Dra och släpp</h3>
    <div class="info-box">
        <p>
            Dra bildfilen från din dator och släpp den direkt på det ljusblå fältet. Bilden
            laddas upp automatiskt.
        </p>
    </div>

    <h2>Fyll i bilduppgifter</h2>

    <div class="step">
        <p class="step-number">Steg 4: Ge bilden en titel</p>
        <p>
            När bilden har laddats upp fylls fältet
            <span class="highlight">"Titel"</span> automatiskt i med bildens filnamn. Du kan
            ändra detta till en mer beskrivande titel för din egen administration och för
            att lättare identifiera bilden i systemet.
        </p>
    </div>

    <div class="note">
        <strong>ℹ️ Obs:</strong> Titel och kommentar är inte synliga under röstningen -
        röstningen sker anonymt baserat enbart på bilderna. Däremot kommer kommentaren att
        visas i den PDF som skapas när tävlingen är avslutad.
    </div>

    <div class="step">
        <p class="step-number">Steg 5: Lägg till en kommentar (valfritt)</p>
        <p>
            Under titelfältet finns ett kommentarsfält. Eftersom kommentaren kommer att
            synas i slutresultatet när tävlingen är över kan du här:
        </p>
        <ul>
            <li>Berätta historien bakom bilden</li>
            <li>Beskriva dina vedermödor vid fotograferandet</li>
            <li>Dela vad som gjorde motivet speciellt</li>
            <li>Förklara tekniska detaljer om bilden</li>
            <li>Göra personliga anteckningar för dig själv</li>
        </ul>
        <p>
            Kommentarsfältet har enkel textformatering där du kan använda fetstil, kursiv,
            understrykning samt punktlistor och numrerade listor.
        </p>
    </div>

    <div class="step">
        <p class="step-number">Steg 6: Spara din bild</p>
        <p>
            När du är nöjd med titel och kommentar, klicka på den blå knappen
            <strong>"Ok"</strong> längst ner i uppladdningsrutan för att spara din bild till
            tävlingen.
        </p>
    </div>

    <h2>Redigera och ta bort bilder</h2>

    <div class="step">
        <p class="step-number">Redigera titel och kommentar</p>
        <p>
            Om du vill ändra titel eller kommentar för en bild du redan har laddat upp,
            klicka på <strong>penn-ikonen</strong> vid bilden. Då öppnas samma
            uppladdningsruta där du kan uppdatera informationen.
        </p>
    </div>

    <div class="step">
        <p class="step-number">Ta bort en bild</p>
        <p>
            Om du vill ta bort en bild från tävlingen, klicka på
            <strong>minustecknet (-)</strong> vid bilden. Bilden raderas permanent från
            tävlingen.
        </p>
    </div>

    <div class="note">
        <strong>⚠️ Varning:</strong> När du tar bort en bild är det permanent - du måste
        ladda upp bilden igen om du ångrar dig.
    </div>

    <h2>Vanliga frågor</h2>

    <div class="info-box">
        <h3>❓ Hur många bilder kan jag ladda upp?</h3>
        <p>
            Det beror på tävlingens regler. Kontrollera med tävlingsarrangören om det finns
            någon gräns för antal bilder per deltagare eller tema.
        </p>
    </div>

    <div class="info-box">
        <h3>❓ Kan jag redigera eller ta bort en bild efter uppladdning?</h3>
        <p>Ja! Du kan när som helst:</p>
        <ul>
            <li>
                <strong>Redigera</strong> - Klicka på penn-ikonen för att ändra titel och
                kommentar
            </li>
            <li>
                <strong>Ta bort</strong> - Klicka på minustecknet (-) för att radera bilden
                permanent
            </li>
        </ul>
    </div>

    <div class="info-box">
        <h3>❓ Vilka bildformat kan jag ladda upp?</h3>
        <p>
            Endast JPEG-bilder (med filändelse .jpg eller .jpeg) kan laddas upp till
            tävlingen.
        </p>
    </div>

    <div class="info-box">
        <h3>❓ Måste jag fylla i kommentarsfältet?</h3>
        <p>
            Nej, kommentarsfältet är valfritt. Men en bra beskrivning kan göra din bild mer
            intressant för både röstare och andra deltagare!
        </p>
    </div>

    <h2>Behöver du hjälp?</h2>
    <p>
        Om du stöter på problem vid uppladdning eller har frågor om tävlingen, kontakta
        tävlingsarrangören.
    </p>

    <p style="margin-top: 40px; text-align: center; color: #666; font-size: 0.9em">
        Lycka till med din bild! 🎉📷
    </p>
</div>